<template>
    <div class="animate__animated animate__fadeInUp">
        <v-card-title><span v-html="$th('support.rules.title')"></span></v-card-title>
        <v-card-text>
            <div v-html="$t('support.rules.foreword')" class="mb-5"></div>
            <span v-for="(rule, index) in get_list('support.rules.rules')" :key="index">{{index + 1}}. <span v-html="rule"></span><br></span>
            <br><br>
            <span v-html="$th('support.rules.thank-you')"></span>
        </v-card-text>
    </div>
</template>


<script>
    export default {
        methods: {
            // Returns the list behind a translation key, an empty list when the key does not exist
            get_list(key) {
                const list = this.$t(key);
                return Array.isArray(list) ? list : [];
            },
        },
        metaInfo() {
            return {
                title: `${this.$t('meta.page-title-unformated')} - ${this.$t('meta.page-title-rules')}`,
                meta : [{
                    name   : "description",
                    content: this.$t("meta.description"),
                }]
            }
        },
    }
</script>